
export enum TaskStatus {
    Open = 'Open',
    Completed = 'Completed',
}

export enum TaskPhaseName {
    Before = 'Before',
    During = 'During',
    After = 'After',
}

export enum DailyPhaseName {
    CheckIn = 'Daily Check-In',
    CheckOut = 'Daily Check-Out',
}

export type TaskPhaseType = TaskPhaseName | DailyPhaseName;

export enum TaskTarget {
    Office = 'Office',
    Supervisor = 'Supervisor',
    Field = 'Field'
}

export enum TaskGroupBy {
    None = 'None',
    //Legacy = 'Legacy',
    Stage = 'Stage',
    Phase = 'Phase',
    Assignee = 'Assignee',
    Location = 'Location',
    Tags = 'Tags',
    Target = 'Target',
    Type = 'Type',
    Status = 'Status',
}

export const TaskPhaseNames = Object.values(TaskPhaseName);
export const DailyPhaseNames = Object.values(DailyPhaseName);
export const TaskTargets = Object.values(TaskTarget);
export const TaskGroupBys = Object.values(TaskGroupBy);

export enum TaskLinkType {
    Project = 'Project',
    Job = 'Job',
    Work = 'Work',
    WorkOrder = 'WorkOrder',
    Employee = 'Employee',
    JobTemplate = 'Job Template',
    Opportunity = "Opportunity",
    Contact = 'Contact',

    Task = 'Task',
    // Code = 'Code',
    Phase = 'Phase',
    Daily = 'Daily',
    Checklist = 'Checklist',
    Compliance = 'Compliance',
    LegacyCompliance = 'Legacy Compliance',

    Item = 'Item',
    ItemTask = 'Item Task',
    /** Marker on `links` for SOR line-item trees. Wrapper `type` stays Item. */
    SOR = 'SOR',

    // This is using on group by stuff
    Group = 'Group',
    Assignee = 'Assignee',
    Location = 'Location',
    Type = 'Type',
    Tags = 'Tags',
    Target = 'Target',
    Status = 'Status',
    Site = 'Site',
    IntegrationId = 'IntegrationId',
}

export enum TaskCopyDestination {
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    Code = 'Code',
    Checklist = 'Checklist',
}

import { ActivityEntityName } from '../shared/activity.entity.name';

/**
 * Maps TaskLinkType to ActivityEntityName where a direct mapping exists.
 * Only includes TaskLinkTypes that have a corresponding ActivityEntityName.
 */
export const TaskLinkTypeToActivityEntityName: Partial<Record<TaskLinkType, ActivityEntityName>> = {
    [TaskLinkType.Project]: ActivityEntityName.Project,
    [TaskLinkType.Job]: ActivityEntityName.Job,
    [TaskLinkType.Work]: ActivityEntityName.WorkOrder,
    [TaskLinkType.WorkOrder]: ActivityEntityName.WorkOrder,
    [TaskLinkType.Employee]: ActivityEntityName.Employee,
    [TaskLinkType.JobTemplate]: ActivityEntityName.JobTemplate,
    [TaskLinkType.Opportunity]: ActivityEntityName.Opportunity,
    [TaskLinkType.Contact]: ActivityEntityName.Contact,
    [TaskLinkType.Task]: ActivityEntityName.Task,
    [TaskLinkType.Compliance]: ActivityEntityName.Compliance,
    [TaskLinkType.Item]: ActivityEntityName.Item,
    [TaskLinkType.Site]: ActivityEntityName.Site,
};

/**
 * Gets the ActivityEntityName for a TaskLinkType, or undefined if no mapping exists.
 */
export function getActivityEntityNameFromTaskLinkType(linkType: TaskLinkType | { type: TaskLinkType }): ActivityEntityName | undefined {

    if (typeof linkType === 'object') {
        return TaskLinkTypeToActivityEntityName[linkType.type];
    }

    return TaskLinkTypeToActivityEntityName[linkType];
}